require('es6-promise').polyfill();
require('isomorphic-fetch');

const serialize = (base = "", params) => {
  return objectLength(params) === 0
    ? base
    : base +
        "?" +
        Object.keys(params)
          .map(function(k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
          })
          .join("&");
};

const objectLength = object => Object.keys(object).length;

export default () => {
  const fetcher = (url = "", params = {}, method = "GET", content = {}) => {
    url = urlMaker(url, params);

    content.method = method;

    if (objectLength(params) > 0 && method === "GET" && url !== false) {
      url = serialize(url, params);
    }

    if (objectLength(params) > 0 && method !== "GET") {
      content.body = JSON.stringify(params);
    }

    if (url !== false) {
      return fetch(url, content)
        .then(r => {
          if (r.status === 200 || r.status === 201) {
            return r.json();
          } else {
            return Promise.reject(new Error("Error " + r.status));
          }
        })
        .catch(e => e);
    } else {
      return Promise.reject(new Error("Bad params"));
    }
  };

  const get = (url = "", params = {}, optionalContent = {}) => {
    return fetcher(url, params, "GET", optionalContent);
  };

  const post = (url = "", params = {}, optionalContent = {}) => {
    return fetcher(url, params, "POST", optionalContent);
  };

  const soap = (params = {}) => {
    
  };

  const urlMaker = (url = "", params) => {
    const expression = /:[a-z]+\//gi;
    let newUrl = url,
      matches = url.match(expression);

    if (matches != null) {
      matches.map(fullItem => {
        let item = fullItem.substring(1, fullItem.length - 1);
        if (newUrl !== false && params[item] != null) {
          newUrl = newUrl.replace(":" + item, params[item]);
        } else {
          newUrl = false;
        }
      });
    }

    return newUrl;
  };

  return {
    get,
    post,
    soap
  };
};